import Livesearch from 'adeliom-livesearch-js';
import 'adeliom-livesearch-js/dist/livesearch.css';

const livesearchPath = document.querySelector('meta[name="livesearch-path"]');

const getLivesearchPath = () => {
  return livesearchPath.getAttribute('content');
}

if (livesearchPath) {
  const settings = {
    pathAjax: getLivesearchPath(),
    submitSelector: '',
    minimumTimeLoading: 1000,
    paramsInUrl: true,
    animationScrollTo: 'smooth',
    pageKey: 'page',
    handleArraysNatively: true,
    perPage: 8,
    displayFirstPageInUrl: false
  };

  const livesearch = new Livesearch(settings);

  const updatePlaceholer = () => {
    const filtersGroup = document.querySelectorAll('[data-key]');

    filtersGroup.forEach((filterGroup) => {
      const inputs = filterGroup.querySelectorAll('input');
      const placeholdersArray = [];
      inputs.forEach((activeInput) => {
        if (activeInput.checked) {
          placeholdersArray.push(activeInput.nextElementSibling.textContent);
        }
      });
      /** @var {HTMLElement} placeholder */
      const placeholder = filterGroup.querySelector('[data-placeholder]');
      if (placeholdersArray.length) {
        placeholder.innerHTML = placeholdersArray.join(', ');
      } else {
        placeholder.innerHTML = placeholder.dataset.placeholder;
      }
    });
  };

  const disableInput = () => {
    const filtersGroup = document.querySelectorAll('[data-key]');
    filtersGroup.forEach((filterGroup) => {
      const inputs = filterGroup.querySelectorAll('input');
      inputs.forEach((activeInput) => {
        if (activeInput.checked) {
          filtersGroup.forEach((filter) => {
            if (
              filter.getAttribute('data-key') !==
              filterGroup.getAttribute('data-key')
            ) {
              const disabledFilters =
                filter.querySelectorAll('input');
              disabledFilters.forEach((disabledFiler) => {
                disabledFiler.setAttribute('disabled', '');
              });
            }
          });
        }
      });
    });
  };

  const addListenerOnButtonsOfPagination = () => {
    const nextBtns = document.querySelectorAll('.paginationNext')
    const previousBtns = document.querySelectorAll('.paginationPrevious')
    /** @var {HTMLElement | null} seoContent */
    const seoContent = document.querySelector('[data-js="review-content-seo"]');

    nextBtns.forEach((button) => {
      button.addEventListener('click', () => {
        if (seoContent && parseInt(button.getAttribute('js-livesearch-page'), 10) > 1) {
          seoContent.remove();
        }
        window.sendEventDataLayerFct('click', 'avis-client', 'suivant')
      })
    })

    previousBtns.forEach((button) => {
      button.addEventListener('click', () => {
        window.sendEventDataLayerFct('click', 'avis-client', 'précédent')
        console.log(parseInt(button.getAttribute('js-livesearch-page'), 10) <= 1)
        if (parseInt(button.getAttribute('js-livesearch-page'), 10) <= 1) {
          const url = new URL(window.location.href);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        }
      })
    })
    console.log(nextBtns, previousBtns)
  }

  const activeInput = () => {
    const disabledInputs = document.querySelectorAll('input:disabled');
    disabledInputs.forEach((disabledInput) => {
      disabledInput.removeAttribute('disabled');
    });
  };

  livesearch.on('beforeChange', () => {
    updatePlaceholer();
    disableInput();
    document
      .querySelector('[js-livesearch-loading]')
      .classList.remove('hidden');
    document
      .querySelector('[js-livesearch-results]')
      .classList.add('hidden');
  });

  livesearch.on('afterChange', (datas) => {
    activeInput();
    document
      .querySelector('[js-livesearch-results]')
      .classList.remove('hidden');
    document
      .querySelector('[js-livesearch-loading]')
      .classList.add('hidden');

    // if (datas.results) {
    //   const countResults = datas.results.realisationsCount;
    //   document.querySelector('.nb-results').innerHTML =
    //     countResults +
    //     ' ' +
    //     (countResults < 2 ? 'réalisation ' : 'réalisations ');
    // } else {
    //   document.querySelector('.no-results').classList.remove('hidden');
    // }

    if (datas.results.filters) {
      Object.keys(datas.results.filters).forEach((filterKey) => {
        const selectFilters = document.querySelectorAll("form [data-filters='" + filterKey + "']");

        selectFilters.forEach((selectFilter) => {
          const filters =
            selectFilter.querySelectorAll('.js-filter-item');
          let nbVisible = 0;
          filters.forEach((filter) => {
            const values = datas.results.filters[filterKey].values;

            const filterId = filter
              .querySelector('input')
              .getAttribute('data-id');

            if (!values[filterId]) {
              filter.classList.add('hidden');
            } else {
              filter.classList.remove('hidden');
              nbVisible++;
            }
          });
          if (nbVisible === 0) {
            selectFilter.classList.add('hidden');
          } else {
            selectFilter.classList.remove('hidden');
          }
        });
      });
    }
    addListenerOnButtonsOfPagination();
  });

  addListenerOnButtonsOfPagination();

  // Reset Form
  const resetBtn = document.querySelectorAll('.reset');
  Array.from(resetBtn).forEach((button) => {
    button.addEventListener('click', () => {
      livesearch.reset();
    });
  });

  livesearch.init();
  updatePlaceholer();
}
